<template>
  <div class="">
    <Navbar />
    <Slider />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Slider from "./Slider.vue";
import axios from "axios";

export default {
  name: "Home",
  components: {
    Navbar,
    Slider,
  },
  data() {
    return {
      pgLoading: true,
      row: "",
    };
  },
  watch: {
    $route() {
      this.fetchHome();
    },
  },
  created() {
    // Check Auth
    if (!localStorage.getItem("access_token")) {
      this.authenticated = false;
    } else {
      this.authenticated = true;
    }

    this.fetchHome();
  },
  methods: {
    fetchHome() {
      axios
        .get(window.baseURL + "/landingPages")
        .then((res) => {
          this.pgLoading = false;
          this.row = res.data.rows;
        })
        .catch(() => {});
    },
  },
};
</script>
